(function () {
  function getHeights(element) {
    var mobile = parseInt(element.dataset.collapsedHeightMobile, 10);
    var desktop = parseInt(element.dataset.collapsedHeightDesktop, 10);

    if (isNaN(mobile)) mobile = 220;
    if (isNaN(desktop)) desktop = 300;

    return { mobile: mobile, desktop: desktop };
  }

  function currentLimit(element) {
    var heights = getHeights(element);
    var isDesktop = window.matchMedia('(min-width: 750px)').matches;
    return isDesktop ? heights.desktop : heights.mobile;
  }

  function initDescription(desc) {
    var btn = desc.nextElementSibling;
    if (!btn || !btn.classList.contains('product-description__toggle')) return;

    if (desc.dataset.userToggled === 'true') {
      var heights = getHeights(desc);
      desc.style.setProperty('--collapsed-height-mobile', heights.mobile + 'px');
      desc.style.setProperty('--collapsed-height-desktop', heights.desktop + 'px');
      return;
    }

    var heights = getHeights(desc);
    desc.style.setProperty('--collapsed-height-mobile', heights.mobile + 'px');
    desc.style.setProperty('--collapsed-height-desktop', heights.desktop + 'px');

    var fullHeight = desc.scrollHeight;
    var limit = currentLimit(desc);

    if (fullHeight > limit) {
      desc.classList.add('is-collapsed', 'has-toggle');
      btn.removeAttribute('hidden');
      btn.style.display = '';
      var moreLabel = btn.getAttribute('data-more') || 'Leer más';
      btn.textContent = moreLabel;
    } else {
      desc.classList.remove('is-collapsed', 'has-toggle');
      btn.setAttribute('hidden', 'hidden');
      btn.style.display = 'none';
    }
  }

  function initAllDescriptions() {
    var descriptions = document.querySelectorAll('.product-description--collapsible');
    descriptions.forEach(initDescription);
  }

  document.addEventListener('click', function (event) {
    var btn = event.target.closest('.product-description__toggle');
    if (!btn) return;

    var desc = btn.previousElementSibling;
    if (!desc || !desc.classList.contains('product-description--collapsible')) return;

    var moreLabel = btn.getAttribute('data-more') || 'Leer más';
    var lessLabel = btn.getAttribute('data-less') || 'Leer menos';

    if (desc.classList.contains('is-collapsed')) {
      desc.classList.remove('is-collapsed');
      btn.textContent = lessLabel;
    } else {
      desc.classList.add('is-collapsed');
      btn.textContent = moreLabel;
    }
    desc.dataset.userToggled = 'true';
  });

  var resizeTimeout;
  function onResize() {
    clearTimeout(resizeTimeout);
    resizeTimeout = setTimeout(initAllDescriptions, 200);
  }

  document.addEventListener('DOMContentLoaded', initAllDescriptions);
  window.addEventListener('resize', onResize);
})();
